import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledOnboardingHubContent = styled(FlexColumn)<{ inSidebar?: boolean }>`
    ${({ inSidebar }) =>
        inSidebar
            ? `
    height: auto;
    min-width: auto;
  `
            : `
    height: 706px;
    min-width: 392px;
  `}
`;

export const OnboardingHubHeaderWrapper = styled.div`
    padding: 16px 16px 0 16px;
`;

export const StyledShadowBlockTopCover = styled.div`
    width: 100%;
    height: 22px;
    background-color: ${colorsPalettes.carbon[0]};
    z-index: 999;
    position: relative;
`;
export const StyledShadowBlockBottomCover = styled(StyledShadowBlockTopCover)`
    margin: 0 -16px 0 -16px;
    width: calc(100% + 32px);
    height: 8px;
`;

export const StyledShadowBlock = styled.div`
    z-index: 99;
    box-shadow: 0 3px 6px 1px rgba(14, 30, 62, 0.08);
    position: relative;
`;

export const StyledOnboardingHubContentBodyWrapper = styled(FlexColumn)<{ isInSidebar?: boolean }>`
    ${({ isInSidebar = false }) =>
        isInSidebar
            ? `
        gap: 8px;
        padding:0;
        `
            : `gap: 16px;
               padding: 0 16px 16px 16px;
    `}
`;
